const monitorMain = () => import(/* webpackChunkName: "group-pabx-monitor" */ '../views/monitorMain')

import MonitorRamaisRoute from '../modules/ramais/_routes'

export default [
  {
    path: 'monitor',
    meta: { requiresAuth: true, permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_PABX_HABILITADO] },
    component: monitorMain,
    children: [...MonitorRamaisRoute],
  },
]
